import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconIntegrationChanged = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M12 19.75C11.59 19.75 11.25 19.41 11.25 19V16C11.25 15.59 11.59 15.25 12 15.25C12.41 15.25 12.75 15.59 12.75 16V19C12.75 19.41 12.41 19.75 12 19.75Z"
      fill="#31A4FF"
    />
    <path
      d="M12 23.75C10.48 23.75 9.25 22.52 9.25 21C9.25 19.48 10.48 18.25 12 18.25C13.52 18.25 14.75 19.48 14.75 21C14.75 22.52 13.52 23.75 12 23.75ZM12 19.75C11.31 19.75 10.75 20.31 10.75 21C10.75 21.69 11.31 22.25 12 22.25C12.69 22.25 13.25 21.69 13.25 21C13.25 20.31 12.69 19.75 12 19.75Z"
      fill="#31A4FF"
    />
    <path
      d="M18 21.75H14C13.59 21.75 13.25 21.41 13.25 21C13.25 20.59 13.59 20.25 14 20.25H18C18.41 20.25 18.75 20.59 18.75 21C18.75 21.41 18.41 21.75 18 21.75Z"
      fill="#31A4FF"
    />
    <path
      d="M10 21.75H6C5.59 21.75 5.25 21.41 5.25 21C5.25 20.59 5.59 20.25 6 20.25H10C10.41 20.25 10.75 20.59 10.75 21C10.75 21.41 10.41 21.75 10 21.75Z"
      fill="#31A4FF"
    />
    <circle
      cx="12"
      cy="8.90161"
      r="6.90161"
      stroke="#31A4FF"
      strokeWidth="1.5"
    />
    <path
      d="M13.98 2.29437C15.6204 7.78854 15.5031 10.4199 14.0154 15.4952"
      stroke="#31A4FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0142 2.30719C8.37378 7.80136 8.49099 10.4328 9.97872 15.508"
      stroke="#31A4FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.41839 6.91213C10.8849 5.27173 13.503 5.38894 18.5526 6.87666"
      stroke="#31A4FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.43109 10.8779C10.8975 12.5183 13.5157 12.4011 18.5653 10.9134"
      stroke="#31A4FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
